@if (alertType != 'N/A') {
  <div 
    class="map-alert flex align-items-center justify-content-center gap-spacing-xl py-spacing-3xs px-spacing-xl"
    [ngClass]="{
      'icon-info-alpha-80-bg': alertType == 'None',
      'icon-warning-alpha-80-bg': alertType != 'None',
    }">
    <span class="flex align-items-center gap-spacing-2xs border-1 background-surface-base-alpha-50-border radius-sm py-spacing-3xs px-spacing-2xs">
      <i class="size-icon-sm text-inverse-color"
        [ngClass]="{
          'icon-info-solid': alertType == 'None',
          'icon-broadcast-solid': alertType == 'GPSLost',
          'icon-wifi-slash-solid': alertType == 'ConnectionLost',
          'icon-warning-solid': alertType == 'Warning'
        }">
      </i>
      <span class="body-small-bold text-inverse-color">
        {{ alertType == 'None' ? 'Ride not started yet' : 
          alertType == 'ConnectionLost' ? 'Connection Lost' : 
          alertType == 'Warning' ? 'Warning' : 
          alertType == 'GPSLost' ? 'GPS Signal Lost' : '' }}
      </span>
    </span>
    <p class="mb-0 body-small-bold text-inverse-color">
      {{ alertType == 'None' ? 'GPS tracking will begin when the driver starts the ride' : 
        alertType == 'ConnectionLost' ? 'Attempting to reconnect...' : 
        alertType == 'Warning' ? 'The driver just missed a turn' : 
        alertType == 'GPSLost' ? ('Last known location at ' + formattedLastKnownTime()) : '' }}
    </p>
  </div>
}
<div #mapContainer class="map-container border-round-bottom-lg overflow-hidden">
  <div #mapDiv class="custom-goole-map pro-map" style="width: 100%; height: 100%;"></div>

  <div class="map-legend-container">
    <div
      class="map-legend flex flex-column py-spacing-md px-spacing-xl gap-spacing-xs border-round-lg border-1 border-brand-lighter-border">
      <div class="item flex gap-spacing-md align-items-center">
        <span class="dot planned"></span>
        <span class="body-medium-regular text-inverse-color">Planned Route</span>
      </div>
      <div class="item flex gap-spacing-md align-items-center">
        <span class="dot actual"></span>
        <span class="body-medium-regular text-inverse-color">Actual Route</span>
      </div>
      <div class="item flex gap-spacing-md align-items-center">
        <span class="dot deviations"></span>
        <span class="body-medium-regular text-inverse-color">Deviations</span>
      </div>
    </div>
  </div>
</div>
